import { render, staticRenderFns } from "./ReviewersAndEvaluate.vue?vue&type=template&id=724064e8&"
import script from "./ReviewersAndEvaluate.vue?vue&type=script&lang=js&"
export * from "./ReviewersAndEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./ReviewersAndEvaluate.vue?vue&type=style&index=0&id=724064e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports